<template>
  <v-card>
    <CronServiceBusDialog
    ref="cronServiceBusDialog"
    v-model="CronServiceBusDialog"
    @closed="onCronServiceBusDialogClosed">
    </CronServiceBusDialog>
    <div class="elevation-1 mb-1 pb-2">
      <v-card-title>
        {{$t("scheduler.schedules")}}
        <v-btn
          small
          @click="openScheduleDialog(null)"
          color="primary"
          class="ml-3"
        >
          <v-icon left>mdi-plus</v-icon>
          {{$t("common.addNew")}}
        </v-btn>
      </v-card-title>
    </div>
    <v-skeleton-loader :loading="loading" :transition-group="'scale-transition'" type="table">
      <v-data-table
        :headers="showableHeaders"
        :items="schedules"
        item-key="Id"
        :item-class="transportEventRowClass"
        :options.sync="options"
        :searchTotalCount="searchTotalCount"
        :multi-sort="multisortEnabled"
        :search="filter"
        :loading="loadingPage"
        calculate-widths
        :hide-default-footer="true"
      >
        <template v-slot:item.createdAt="{ item }">
            {{ formatDate(item.createdAt) }}
        </template>
        <template v-slot:item.cronTickerCustomName="{ item }">
            <span class="truncate-name" :title="item.customProperties.CronTickerCustomName">
                {{ item.customProperties.CronTickerCustomName }}
            </span>
        </template>
        <template v-slot:item.edit="{ item }">
            <div style="display: flex; align-items: center;">
                <v-btn
                small
                @click="openScheduleDialog(item)"
                color="primary"
                class="ml-3"
                >
                <v-icon left>mdi-cog</v-icon>
                    {{$t("common.edit")}}
                </v-btn>
                <v-btn
                small
                @click="deleteSchedule(item.id)"
                color="primary"
                class="ml-3"
                >
                <v-icon left>mdi-delete</v-icon>
                    {{$t("common.delete")}}
                </v-btn>
            </div>
        </template>
      </v-data-table>
    </v-skeleton-loader>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn text @click="snackbar = false">
        {{$t("common.close")}}
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import CronServiceBusDialog from "@/components/Scheduler/CronServiceBusDialog";
import moment from "moment";

export default {
    components: { CronServiceBusDialog },
    mixins: [ ],
    data() {
        return {
            loading: true,
            loadingCSV: false,
            filter: "",
            columnDialog: false,
            searchDialog: false,
            modelOptions: ["All", "Likuma", "Kela"],
            loadingPage: false,
            searchParams: {
                validationStates: [],
                modifiedFrom: moment().subtract(14, "days").format()
            },
            itemsPerPageOptions: [5, 10, 20, 50, 100],
            selectedTransportEvent: null,
            snackbar: false,
            snackbarText: "",
            snackbarColor: "",
            headers: [
                { text: "Created at", value: "createdAt", show: true },
                { text: "Expression", value: "cronExpression", show: true },
                { text: "Name", value: "cronTickerCustomName", show: true },
                { text: "Function", value: "function", show: true },
                { text: "Retries", value: "retries", show: true },
                { text: "RetryIntervals", value: "retryIntervals", show: true },
                { text: "Edit", value: "edit", show: true }
            ],
            schedules: [],
            CronServiceBusDialog: false
        };
    },
    computed: {
        searchTotalCount() {
            return this.$store.state.transportEventTable.searchTotalCount;
        },
        multisortEnabled() {
            return this.searchTotalCount <= 50000; // Production backend can handle with ease
        },
        options: {
            get() {
                let options = this.$store.state.transportEventTable.options;
                // hack to trigger this getter
                // eslint-disable-next-line no-unused-vars
                let { page, itemsPerPage, sortBy, sortDesc } = options;
                return options;
            },
            set(val) {
                this.$store.dispatch("transportEventTable/updateOptions", val);
            }
        },
        showableHeaders() {
            return this.headers.filter(h => h.show);
        },
        pagination() {
            return {
                page: this.options.page,
                itemsPerPage: this.options.itemsPerPage,
                pageStart: ((this.options.page - 1) * this.options.itemsPerPage),
                pageStop: (this.options.page * this.options.itemsPerPage),
                pageCount: Math.ceil(this.searchTotalCount / this.options.itemsPerPage),
                itemsLength: this.searchTotalCount
            };
        },
        extensions() {
            return this.$store.state.transportEventTable.extensions || {};
        },
        tenant() {
            return this.$store.state.user.tenant;
        },
        totalReimbursementSum() {
            return this.extensions.TotalReimbursementSum || 0;
        },
        sortByParams() {
            if (!this.options.sortBy || this.options.sortBy.length < 1) return null;
            let sortByValues = [];
            for (let [index, val] of this.options.sortBy.entries()) {
                let orderById = this.headers.find((header) => header.value === val).orderById;
                let direction = this.options.sortDesc[index] ? "desc" : "asc";
                sortByValues.push(orderById + ":" + direction);
            }
            return { orderBy: sortByValues };
        }
    },
    watch: {
        tenant(val) {
            this.resetColumns();
            this.searchSchedules(null, true);
        },
        options: {
            handler(val) {
                this.searchSchedules(null, false, true);
            },
            deep: true
        },
        multisortEnabled(val) {
            this.options.multiSort = val;
        }

    },
    methods: {
        async getSchedules(searchParams = null, forceUpdate = false, sortByUpdate = false) {
            if (sortByUpdate) {
                this.loadingPage = true; // For smoother UX if only sorting is updated
            } else {
                this.loading = true;
            }
            var response = await this.$store.dispatch("cronScheduler/getSchedules")
                .catch(error => {
                    this.snackbar = true;
                    this.snackbarColor = "error";
                    this.snackbarText = error;
                })
                .finally(() => {
                    this.loadingPage = false;
                    this.loading = false;
                });
            this.schedules = response.data;
        },
        openScheduleDialog(schedule) {
            this.CronServiceBusDialog = true;
            this.$refs.cronServiceBusDialog.openDialog(schedule);
        },
        deleteSchedule(id) {
            this.$store
                .dispatch("cronScheduler/deleteSchedule", id)
                .then(() => {
                    this.snackbarText = "Schedule deleted successfully.";
                    this.snackbarColor = "success";
                    this.snackbar = true;
                    this.searchSchedules(this.$route.query);
                })
                .catch(error => {
                    this.snackbarText = error;
                    this.snackbarColor = "error";
                    this.snackbar = true;
                });
        },
        transportEventDeleted() {
            this.snackbarText = "Transport event was successfully deleted.";
            this.snackbarColor = "success";
            this.snackbar = true;
            this.closeScheduleDialog();
        },
        closeScheduleDialog() {
            this.selectedTransportEvent = null;
            this.transportEventDialog = false;
        },
        searchSchedules(searchParams = null, forceUpdate = false, sortByUpdate = false) {
            if (searchParams) {
                this.searchParams = searchParams;
                // Reset page only when new search parameters are provided
                this.$store.dispatch("transportEventTable/updateOptions", { ...this.options, page: 1 });
            }
            this.getSchedules(this.searchParams, forceUpdate, sortByUpdate);
            this.searchDialog = false;
        },
        transportEventRowClass(item) {
            if (item.removed) return "itemRow-removed";
            return "";
        },
        resetColumns() {
            this.$store.dispatch("transportEventTablePersisted/resetHeaders");
        },
        formatDate(date) {
            return date ? moment(date).format("YYYY-MM-DD HH:mm") : "";
        },
        onCronServiceBusDialogClosed() {
            this.CronServiceBusDialog = false;
            // Add your custom logic here, e.g.:
            this.searchSchedules(this.$route.query);
        }
    },
    filters: {
        statusToColor: function(value) {
            switch (value) {
            case 1:
            case 2:
                return "";
            case 3: return "success";
            default: return "error";
            };
        },
        statusToIcon: function(value) {
            switch (value) {
            case 1:
            case 2:
                return "mdi-av-timer";
            case 3: return "mdi-check-circle-outline";
            default: return "mdi-alert";
            };
        },
        statusToToolTipText: function(value) {
            switch (value) {
            case 1:
            case 2:
                return "Waiting";
            case 3: return "No errors";
            default: return "Contains error(s)";
            };
        }
    },
    created() {
        if (!this.headers || this.headers.length < 1) this.resetColumns();
        this.searchSchedules(this.$route.query);
    }
};
</script>

<style>
.v-text-field_search {
    padding-top: 0;
    margin-top: 0;
}
.extras-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.extras-list > li > span:last-of-type {
    float: right;
    margin-left:10px
}

.itemRow-removed {
  background-color: #bfbfbf;
}

.itemRowSideColor-grey {
    border: 5px solid #BDBDBD;;
    background-color: #BDBDBD;
    border-radius: 3px;
    display: inline;
}
.itemRowSideColor-blue {
    border: 5px solid #42A5F5;
    background-color: #42A5F5;
    border-radius: 3px;
    display: inline;
}
.itemRowSideColor-green {
    border: 5px solid #66BB6A;
    background-color: #66BB6A;
    border-radius: 3px;
    display: inline;
}
.itemRowSideColor-yellow {
    border: 5px solid #FFEE58;
    background-color: #FFEE58;
    border-radius: 3px;
    display: inline;
}
.itemRowSideColor-orange {
    border: 5px solid #FFA726;
    background-color: #FFA726;
    border-radius: 3px;
    display: inline;
}
.line-limit-3 {
  overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-line-clamp: 3; /* number of lines to show */
           line-clamp: 3;
   -webkit-box-orient: vertical;
}
.comments-tooltip {
  white-space: pre-line;
  max-width: 400px;
}
.truncate-name {
  display: inline-block;
  max-width: 220px; /* adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
